import React from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { useSelector } from 'react-redux';
import useYAxisFormatter from '../Sharedfeatures/useYAxisFormatter';

const YearWise = () => {
    const { yearData } = useSelector((state) => state.dashboard)
    const { dataFormater } = useYAxisFormatter();

    let data = [];
    let cdata = {
        name: "Year",
        count: yearData.count,
        amount: yearData.amount
    };
    data.push(cdata);


    // const data = [
    //     {
    //         name: "2022",
    //         uv: 3600,
    //         pv: 2400,
    //         amt: 2400
    //     }
    // ];
    return (
        <div className='loan-disbursed-region-wise'>
            <ResponsiveContainer width="95%" height="95%">
                <BarChart
                    width={500}
                    height={500}
                    data={data}
                    margin={{
                        top: 15,
                        right: 30,
                        left: 20,
                        bottom: -8,
                    }}
                    barSize={60}
                >
                    <XAxis dataKey="name" axisLine={false} />
                    <YAxis axisLine={false} tickFormatter={dataFormater} />
                    <Tooltip cursor={false}
                    // content={<CustomTooltip />} 

                    />
                    <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
                    <Bar dataKey="count" fill="#7C4DFF" />
                    <Bar dataKey="amount" fill="#7C4DFF" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default YearWise